<template>
  <button class="trbo-a-question-close-button" :aria-label="$t('wizard.noRecommendationCloseButtonTitle')" @click="onClick">
    <icon name="close" class="trbo-a-question-close-button__icon" />
  </button>
</template>

<script>
// @flow

import Icon from '../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped src="./question-close-button.scss" />
